<template>
  <div class="error_topic">
    <div class="header">
      <span class="goback" @click="GoBack">
        <i class="iconfont">&#xe629;</i>
      </span>
    </div>
    <div class="content">
      <div class="topic" v-if="step == 1">
        <div class="title">
          <span class="topic_Num" v-if="TopicData && TopicData.length"
            >{{ currIndex + 1 }}、{{
              TopicData.length && TopicData[currIndex].examTypeDesc
            }}</span
          >
          <span v-else></span>
          <span class="report_problem" @click="onImproveProblems('mw'+TopicData[currIndex].id)"
            ><i class="iconfont wenhao">&#xe601;</i>我要纠错</span>
			<el-dialog
				:visible.sync="problemsPopover"
				top="35vh"
				width="432px"
				custom-class="EscModal"
				@closed="problemDialogClosed"
				:key="'mw'+TopicData[currIndex].id"
			>
				<div :id="'pop'+index" style="height:140px;">
					<el-checkbox-group v-model="textarea" style="margin-left:80px;width: 65%;">
						<el-checkbox value="参考答案不正确" label="参考答案不正确" style="float:left;">
							<span style="font-size: 20px;line-height: 25px;">参考答案不正确</span>
						</el-checkbox>
						<el-checkbox value="视频解析不对应" label="视频解析不对应" style="float:left;">
							<span style="font-size: 20px;line-height: 25px;">视频解析不对应</span>
						</el-checkbox>
						<el-checkbox value="解析不正确" label="解析不正确" style="float:left;">
							<span style="font-size: 20px;line-height: 25px;">解析不正确</span>
						</el-checkbox>
						<el-input v-model="inputTextarea" placeholder="有其他问题？请在此处填写"
								  style="font-size:20px;line-height:30px;float:left;margin-bottom:5px;"></el-input>
					</el-checkbox-group>
					<div style="text-align: right; float:right; margin: 0">
						<el-button size="mini" type="text" @click="problemsPopover = false">取消
						</el-button>
						<el-button type="primary" size="mini" @click="reportProblem(TopicData[currIndex].id)">
							确定
						</el-button>
					</div>
				</div>
			</el-dialog>
        </div>
        <div class="topic_content" v-if="TopicData && TopicData.length">
          <div class="content_html" v-html="TopicData[currIndex].content"></div>
          <div class="topic_option" v-if="TopicData[currIndex].examType == 1">
            <el-radio-group v-model="radioValue" @change="clickOption">
              <div
                v-for="(item, index) in TopicData[currIndex].info"
                :key="index"
              >
                <div class="option_item">
                  <el-radio border :label="item.id" :value="item.id">
                    <span class="space">{{ index | computedNum }}</span>
                    <div class="item_content" v-html="item.content"></div>
                  </el-radio>
                </div>
              </div>
            </el-radio-group>
          </div>
          <div class="topic_option" v-if="TopicData[currIndex].examType == 2">
            <el-checkbox-group v-model="checkList" @change="clickOption">
              <div
                v-for="(item, index) in TopicData[currIndex].info"
                :key="index"
              >
                <div class="option_item">
                  <el-checkbox border :label="item.id" :value="item.id">
                    <span class="space">{{ index | computedNum }}</span>
                    <div class="item_content" v-html="item.content"></div>
                  </el-checkbox>
                </div>
              </div>
            </el-checkbox-group>
          </div>
          <div class="topic_option" v-if="TopicData[currIndex].examType == 4">
            <el-radio-group v-model="judgeOption" @change="clickOption">
              <div v-for="(item, index) in judgeData" :key="index">
                <div class="option_item">
                  <el-radio
                    border
                    :label="item.isAnswer"
                    :value="item.isAnswer"
                  >
                    <div class="judge_item">
                      {{ item.isAnswer == 1 ? "正确" : "错误" }}
                    </div>
                  </el-radio>
                </div>
              </div>
            </el-radio-group>
          </div>
        </div>
        <div class="next" v-if="TopicData && TopicData.length >= 1">
          <el-button
            class="next_btn"
            :class="isDisabled ? 'isdisabled' : ''"
            :disabled="isDisabled"
            @click="nextTopic"
            >{{
              currIndex + 1 == TopicData.length ? "提交" : "下一题"
            }}</el-button
          >
        </div>
      </div>
      <div class="topic_step2" id="topic_step2" v-if="step == 2">
        <div v-for="(item, index) in topicDetail" :key="index">
          <div class="title">
            <span class="topic_Num" v-if="topicDetail && topicDetail.length"
              >{{ index + 1 }}、{{ item.examTypeDesc }}</span
            >
            <span v-else></span>
            <span class="report_problem" @click="onImproveProblems('mws'+item.id)">我要纠错</span>
			  <el-dialog
				  :visible.sync="problemsPopover"
				  top="35vh"
				  width="432px"
				  custom-class="EscModal"
				  @closed="problemDialogClosed"
				  title="报告问题"
				  :key="'mws'+item.id"
			  >
				  <div :id="'pop'+index" style="height:140px;">
					  <el-checkbox-group v-model="textarea" style="margin-left:80px;width: 65%;">
						  <el-checkbox value="参考答案不正确" label="参考答案不正确" style="float:left;">
							  <span style="font-size: 20px;line-height: 25px;">参考答案不正确</span>
						  </el-checkbox>
						  <el-checkbox value="视频解析不对应" label="视频解析不对应" style="float:left;">
							  <span style="font-size: 20px;line-height: 25px;">视频解析不对应</span>
						  </el-checkbox>
						  <el-checkbox value="解析不正确" label="解析不正确" style="float:left;">
							  <span style="font-size: 20px;line-height: 25px;">解析不正确</span>
						  </el-checkbox>
						  <el-input v-model="inputTextarea" placeholder="有其他问题？请在此处填写"
									style="font-size:20px;line-height:30px;float:left;margin-bottom:5px;"></el-input>
					  </el-checkbox-group>
					  <div style="text-align: right; float:right; margin: 0">
						  <el-button size="mini" type="text" @click="problemsPopover = false">取消
						  </el-button>
						  <el-button type="primary" size="mini" @click="reportProblem(item.id)">
							  确定
						  </el-button>
					  </div>
				  </div>
			  </el-dialog>
          </div>
          <div class="topic_content">
            <div class="topic_title">
              <div class="content_html" v-html="item.content"></div>
              <span :class="item.isRight ? 'right' : 'error'">{{
                item.isRight ? "√" : "×"
              }}</span>
            </div>
            <div class="topic_option" v-if="item.examType == 1">
              <div v-for="(item2, i) in item.info" :key="i">
                <div
                  class="select_option"
                  :class="
                    item2.userSelectFlag && item2.optionRightFlag
                      ? 'select_right'
                      : item2.userSelectFlag && !item2.optionRightFlag
                      ? 'select_error'
                      : ''
                  "
                >
                  <span>{{ i | computedNum }}.</span>
                  <span v-html="item2.content"></span>
                </div>
              </div>
            </div>
            <div class="topic_option" v-if="item.examType == 2">
              <div v-for="(item2, i) in item.info" :key="i">
                <div
                  class="select_option"
                  :class="
                    item2.userSelectFlag && item2.optionRightFlag
                      ? 'select_right'
                      : item2.userSelectFlag && !item2.optionRightFlag
                      ? 'select_error'
                      : ''
                  "
                >
                  <span>{{ i | computedNum }}</span>
                  <span v-html="item2.content"></span>
                </div>
              </div>
            </div>
            <div class="topic_option" v-if="item.examType == 4">
              <div v-for="(item2, i) in item.info" :key="i">
                <div
                  class="select_option"
                  :class="
                    Number(item2.userAnswer) == '0'
                      ? Number(item2.rightAnswer) === Number(item2.userAnswer)
                        ? 'select_right'
                        : 'select_error'
                      : ''
                  "
                >
                  错误
                </div>
                <div
                  class="select_option"
                  :class="
                    Number(item2.userAnswer) == '1'
                      ? Number(item2.rightAnswer) === Number(item2.userAnswer)
                        ? 'select_right'
                        : 'select_error'
                      : ''
                  "
                >
                  正确
                </div>
              </div>
            </div>
            <div v-for="(item2, i) in item.info" :key="i">
              <div
                class="answer_div"
                v-if="
                  item2.optionRightFlag &&
                    item.examType != 3 &&
                    item.examType != 4
                "
              >
                <span>正确答案：</span>
                <span class="answer">{{ i | computedNum }}</span>
              </div>
              <div class="answer_div" v-if="item.examType == 3">
                <span>正确答案：</span>
                <span v-for="(userA, z) in item2.rightAnswer" :key="z">
                  <span class="answer">{{ userA }}</span>
                </span>
              </div>
              <div class="answer_div" v-if="item.examType == 4">
                <span>正确答案：</span>
                <span v-for="(userA, z) in item.info" :key="z">
                  <span class="answer">{{
                    Number(userA.rightAnswer) == "0" ? "错误" : "正确"
                  }}</span>
                </span>
              </div>
            </div>
          </div>
          <div class="knowledge">
            <div class="knowledge_content">
              <span
                >涉及知识点：{{
                  item.knowledgePointDesc ? item.knowledgePointDesc : "暂无"
                }}</span
              >
            </div>
            <div class="intelligent_tutoring" @click="openVideo(item.analysis)">
              类似题解析
            </div>
            <div class="intelligent_tutoring" @click="openVideo(item.videoUrl)">
              智能辅导
            </div>
          </div>
          <div
            class="next"
            v-if="TopicData && TopicData.length > 1 && step !== 2"
          >
            <el-button
              class="next_btn"
              :class="isDisabled ? 'isdisabled' : ''"
              :disabled="isDisabled"
              @click="nextTopic"
              >{{
                currIndex + 1 == TopicData.length ? "提交" : "下一题"
              }}</el-button
            >
          </div>
        </div>
      </div>
      <div id="timerdiv" :class="step == 1 ? 'timer' : 'timer'">
        <div class="time_number">
          <div class="timing">
            <span class="title">答题时间</span>
            <span ref="startTimer" class="number">00:00:00</span>
          </div>
        </div>
        <div class="errdata_record">
          <div class="record_part1">
            <div class="title">错题巩固</div>
            <div class="total_num">{{ groupIdTotal }}</div>
            <div class="wancheng_num">
              - 已做{{ groupIdInfo.remainder ? groupIdInfo.remainder : 0 }}题 -
            </div>
          </div>
          <div class="record_part2">
            <div class="nav1">
              <span class="isright">正确</span>
              <span class="num">{{
                groupIdInfo.rightNum ? groupIdInfo.rightNum : 0
              }}</span>
            </div>
            <div class="nav2">
              <span class="isright">错误</span>
              <span class="num">{{
                groupIdInfo.errorNum ? groupIdInfo.errorNum : 0
              }}</span>
            </div>
          </div>
          <div class="record_part3" v-if="step == 1">
            <div class="btn" @click="endAnswer">结束巩固</div>
          </div>
          <div class="record_part3_step2" v-if="step == 2">
            <div class="btn" @click="Refresh">继续巩固</div>
            <div class="btn" @click="goHome">返回首页</div>
          </div>
        </div>
      </div>
    </div>
    <div>
      <el-dialog
        title="智能辅导"
        :visible.sync="dialogVisible"
        width="580px"
        :before-close="handleClose"
      >
        <div class="video_div">
          <video
            v-if="videoUrl"
            :src="videoUrl"
            width="536px"
            height="288px"
            autoplay="autoplay"
			oncontextmenu="return false"
          ></video>
          <div class="no_videoUrl" v-if="!videoUrl">
            <span>暂无视频讲解</span>
          </div>
        </div>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">没看懂</el-button>
          <el-button type="primary" @click="dialogVisible = false"
            >看懂了</el-button
          >
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import Header from "../components/common/Header";
import Footer from "../components/common/Footer";
import api from "../axios/interface";
export default {
  name: "ErrorContentCapter",
  data() {
    return {
      TopicData: [],
      step: 1,
      currIndex: 0,
      radioValue: "", // 当前单选题选项
      checkList: [], // 当前选择数组
      judgeOption: "",
      timer: "",
      content: "",
      hour: 0,
      minutes: 0,
      seconds: 0,
      currtimer: 0, // 当前计时
      judgeData: [{ isAnswer: 0 }, { isAnswer: 1 }],
	  textbookCapterId: this.$route.query.textbookCapterId,
      isDisabled: true, // 是否可以点击下一题
      errorGroupId: "", // 题组id
      params: {},
      groupIdInfo: {},
      groupIdTotal: 0,
      topicDetail: [],
      dialogVisible: false,
      videoUrl: "",
	  currentSelectedItem: {},
	  problemsPopover: false,
	  centerDialogVisible: false,
	  textarea: [],
	  inputTextarea: "",
    };
  },
  components: {
    Header: Header,
    Footer: Footer
  },
  filters: {
    computedNum(val) {
      let option = "";
      switch (Number(val)) {
        case 0:
          option = "A";
          break;
        case 1:
          option = "B";
          break;
        case 2:
          option = "C";
          break;
        case 3:
          option = "D";
          break;
        case 4:
          option = "E";
          break;
        case 5:
          option = "F";
          break;
        case 6:
          option = "G";
          break;
        case 7:
          option = "H";
          break;
        default:
          option = "";
          break;
      }
      return option;
    }
  },
  watch: {},
  created() {
    clearInterval(this.timer);
    this.timer = setInterval(this.startTimer, 1000);
  },
  mounted() {
    this.getWrongTopic();
    // this.init()
  },
  updated() {
    let that = this;
    // 如果是选择题则在页面渲染完成后给input添加事件
    if (this.TopicData[this.currIndex].examType == 3) {
      this.$nextTick().then(() => {
        $(".tiankong").on("input", function(e) {
          that.clickOption();
        });
      });
    }
  },
  methods: {
	  onImproveProblems(id) {
		  this.problemsPopover = true;
		  this.currentSelectedItem = id;
	  },
	  problemDialogClosed() {
		  this.textarea = [];
		  this.inputTextarea = "";
	  },
	  reportProblem(id) {
		  let that = this;
		  let feedbackContent = "";
		  if(that.textarea.length>0 || that.inputTextarea != ""){
			  that.textarea.forEach((r)=>{
				  feedbackContent += ";"+r;
			  })
			  feedbackContent = that.inputTextarea +feedbackContent;
			  this.$axios.get(api.ErrorTopicFeedback, {id: id, content: feedbackContent}, {hideMessage: true})
				  .then(res => {
					  that.problemsPopover = false;
					  that.$message({
						  showClose: true,
						  message: "纠错信息已提交，谢谢反馈！",
						  duration: 5000,
						  type: "info"
					  });
				  });
		  }
	  },
    init() {
      if (this.step == 2) {
        let timerdiv = $("#timerdiv");
        let topic2 = $("#topic_step2");
        let topic2Top = topic2.offset().top;
        let timerTop = timerdiv.offset().top;
        $.event.add(window, "scroll", () => {
          let p = $(window).scrollTop();
          if (p > timerTop && p > topic2Top) {
            // 到顶部
            timerdiv.css("position", "fixed");
            timerdiv.css("top", 0);
            timerdiv.css("height", "610px");
            timerdiv.css("margin-left", "672px");
          } else {
            timerdiv.css("position", "rilative");
            timerdiv.css("margin-left", "48px");
          }
        });
      }
    },
    // 获取错题本数据统计接口
    getWrongTopic() {
      let that = this;
      this.$axios
        .get(
          api.ExamQuestionListCapter,
          { textbookCapterId: this.textbookCapterId },
          { hideMessage: true }
        )
        .then(res => {
        	if(res.result == null) {
				that.$message({
					showClose: true,
					message: "未发现错题，即将返回...",
					duration: 5000,
					type: "warning"
				});
				setTimeout(function () {
					that.$router.go(-1);
				},4500)
			}else {
				res.result.data.map(item => {
					if (item.examType == 3) {
						item.content = item.content.replace(
							/\[Space\]/g,
							'<input type="text" class="tiankong"/>'
						);
					}
				});
				this.TopicData = res.result.data;
				this.errorGroupId = res.result.groupId;
				this.groupIdTotal = res.result.data.length;
			}
        })
        .catch(res => {});
    },

    Refresh() {
      this.$router.go(0);
    },

    goHome() {
      this.$router.push({
        name: "Home"
      });
    },

    handleClose() {
      this.dialogVisible = false;
    },

    openVideo(url) {
      this.videoUrl = url;
      this.dialogVisible = true;
    },

    // 选择题选项
    clickOption(val) {
      if (this.TopicData[this.currIndex].examType == 1) {
        // 单选题
        this.isDisabled = false;
        this.params = {
          answer: String(val),
          examType: 1,
          id: this.TopicData[this.currIndex].id
        };
      } else if (this.TopicData[this.currIndex].examType == 2) {
        if (this.checkList.length > 1) {
          this.isDisabled = false;
          return;
        } else {
          this.isDisabled = true;
        }
        let answerIds = this.checkList.join(";");
        this.params = {
          answer: answerIds,
          examType: 2,
          id: this.TopicData[this.currIndex].id
        };
      } else if (this.TopicData[this.currIndex].examType == 4) {
        // 判断题
        this.params = {
          answer: String(val),
          examType: 4,
          id: this.TopicData[this.currIndex].id
        };
        this.isDisabled = false;
      } else if (this.TopicData[this.currIndex].examType == 3) {
        // 填空题
        let arr = $(".tiankong");
        let brr = [];
        for (var i = 0, j = arr.length; i < j; i++) {
          brr.push(arr[i].value);
        }
        let answerInput = brr.join(";");
        this.params = {
          answer: answerInput,
          examType: 3,
          id: this.TopicData[this.currIndex].id
        };
        this.isDisabled = false;
      }
    },

    // 下一题
    nextTopic() {
      // 如果当前题不是最后一题
      if (this.currIndex + 1 == this.TopicData.length) {
        this.submit(this.params);
        this.endAnswer();
        // 跳转页面
      } else if (this.currIndex < this.TopicData.length) {
        this.submit(this.params);
        this.currIndex = this.currIndex + 1;
        this.isDisabled = true;
      }
    },

    // 提交当前题目
    submit(params) {
      this.$axios
        .get(
          api.ErrorTopicSubmit,
          {
            ...params,
            groupId: this.errorGroupId
          },
          { hideMessage: true }
        )
        .then(res => {
          this.groupIdInfo = res.result;
          this.isDisabled = true;
        })
        .catch(res => {});
    },

    // 结束订正
    endAnswer() {
      let that = this;
      if (this.TopicData.length == 1) {
        if (this.params && this.params.id) {
          this.submit(this.params);
        } else {
          that.$message({
            showClose: true,
            message: "还未提交答案",
            duration: 1000,
            type: "info"
          });
          return;
        }
      }
      this.step = 2;
      clearInterval(this.timer);
      this.$axios
        .get(
          api.ErrorTopicFinish,
          {
            groupId: this.errorGroupId
          },
          { hideMessage: true }
        )
        .then(res => {
          this.isDisabled = true;
          // this.$axios
          //   .get(
          //     api.ErrorTopicResult,
          //     {
          //       groupId: this.errorGroupId
          //     },
          //     { hideMessage: true }
          //   )
          //   .then(res => {
          //     console.log("答完之后的详情", res);
          //   });
        })
        .catch(res => {});

      // 获取答题详情
      this.$axios
        .get(
          api.ErrorTopicResult,
          {
            groupId: this.errorGroupId
          },
          { hideMessage: true }
        )
        .then(res => {
          this.topicDetail = res.result.data ? res.result.data : [];
        });
    },

    GoBack() {
      this.$router.go(-1);
    },

    startTimer() {
      this.currtimer += 1;
      this.seconds += 1;
      if (this.seconds >= 60) {
        this.seconds = 0;
        this.minutes = this.minutes + 1;
      }

      if (this.minutes >= 60) {
        this.minutes = 0;
        this.hour = this.hour + 1;
      }
      this.$refs.startTimer.innerHTML =
        (this.hour < 10 ? "0" + this.hour : this.hour) +
        ":" +
        (this.minutes < 10 ? "0" + this.minutes : this.minutes) +
        ":" +
        (this.seconds < 10 ? "0" + this.seconds : this.seconds);
    }
  },

  destroyed() {
    clearInterval(this.timer);
  }
};
</script>
<style>
.content_html .tiankong {
  padding: 0 10px;
  width: 60px;
  height: 22px;
  border: none;
  text-align: center;
  background-color: transparent;
  border-bottom: 1px solid #333333;
}
.answer_tiankong {
  padding: 0 10px;
  display: inline-block;
  width: 60px;
  height: 22px;
  text-align: center;
  background-color: transparent;
  border-bottom: 1px solid #333333;
}
.right {
  color: #1dc11d;
}
.error {
  color: #ff0000;
}
.content_html p input:focus {
  outline: none;
  border-bottom: 1px solid #333333 !important;
}
</style>
<style lang='less' scoped>
.error_topic {
  width: 100%;
  min-height: 800px;
  background-color: #87C8FA;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding-bottom: 95px;
  .header {
    width: 1200px;
    height: 48px;
    line-height: 45px;
    margin: 0 auto;
    .goback {
      color: #fff;
      margin-left: 30px;
      i {
        font-size: 23px;
        cursor: pointer;
      }
    }
  }
  .content {
    min-height: 610px;
    margin-top: 56px;
    width: 960px;
    display: flex;
    .topic {
      width: 768px;
      min-height: 610px;
      background-color: #fff;
      position: relative;
      border-radius: 4px;
      .title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 56px;
        padding-left: 24px;
        background-color: #eeeeee;
        .topic_Num {
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }
        .report_problem {
          margin-right: 24px;
          font-size: 14px;
          color: #666666;
          font-weight: 400;
          cursor: pointer;
          .wenhao {
            font-size: 16px;
            padding-top: 5px;
            margin-right: 5px;
          }
        }
      }
      .topic_content {
        padding: 24px 50px 80px 24px;
        color: #333333;
        line-height: 22px;
        .topic_option {
          .option_item {
            position: relative;
            // 单选、判断
            /deep/.el-radio.is-bordered {
              height: auto;
            }
            /deep/.el-radio {
              display: flex;
              height: auto;
              width: 550px;
              max-width: 550px;
              margin-top: 12px;
              padding: 0px 0px 0 0;
              &:first-of-type {
                margin-top: 32px;
              }
              .el-radio__input {
                display: none;
              }
              .el-radio__label {
                display: flex;
                line-height: 40px;
                padding: 0;
                .item_content {
                  padding: 0 20px;
                  max-width: 460px;
                  overflow: hidden;
                  white-space: pre-wrap;
                }
                .space {
                  display: inline-block;
                  text-align: center;
                  width: 40px;
                  height: auto;
                  border-right: 1px solid #dcdfe6;
                }
                .judge_item {
                  padding-left: 20px;
                  width: 530px;
                }
              }
            }
            // 多选
            /deep/.el-checkbox {
              display: flex;
              height: auto;
              width: 550px;
              max-width: 550px;
              margin-top: 12px;
              padding: 0px 0px 0 0;
              &:first-of-type {
                margin-top: 32px;
              }
              .el-checkbox__input {
                display: none;
              }
              .el-checkbox__label {
                display: flex;
                line-height: 40px;
                padding: 0;
                .item_content {
                  padding: 0 20px;
                  max-width: 460px;
                  overflow: hidden;
                  white-space: pre-wrap;
                }
                .space {
                  display: inline-block;
                  text-align: center;
                  width: 40px;
                  height: auto;
                  border-right: 1px solid #dcdfe6;
                }
                .judge_item {
                  padding-left: 20px;
                  width: 530px;
                }
              }
            }
          }
        }
      }
      .next {
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        background-color: #eeeeee;
        height: 56px;
        width: 100%;
        .next_btn {
          cursor: pointer;
          padding: 0 15px;
          font-size: 14px;
          line-height: 28px;
          margin-right: 48px;
          margin: 12px 48px 12px 0;
          height: 28px;
          background-color: #0079fe;
          color: #fff;
          border-radius: 4px;
        }
        .isdisabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
    .topic_step2 {
      width: 768px;
      min-height: 610px;
      background-color: #fff;
      position: relative;
      border-radius: 4px;
      .title {
        display: flex;
        flex-direction: row;
        justify-content: space-between;
        align-items: center;
        height: 56px;
        padding-left: 24px;
        background-color: #eeeeee;
        .topic_Num {
          font-size: 16px;
          color: #333;
          font-weight: 500;
        }
        .report_problem {
          margin-right: 24px;
          font-size: 14px;
          color: #666666;
          font-weight: 400;
          cursor: pointer;
          .wenhao {
            font-size: 16px;
            padding-top: 5px;
            margin-right: 5px;
          }
        }
      }
      .topic_content {
        padding: 24px 50px 24px 24px;
        color: #333333;
        line-height: 22px;
        .topic_title {
          display: flex;
          flex-direction: row;
          justify-content: space-between;
          .content_html {
            width: 420px;
          }
          .right,
          .error {
            display: inline-block;
            width: 32px;
            height: 32px;
            border-radius: 50%;
            text-align: center;
            line-height: 28px;
            color: #fff;
            font-size: 28px;
            font-weight: 600;
          }
          .right {
            background-color: #1dc11d;
          }
          .error {
            background-color: #ff0000;
          }
        }
        .answer_div {
          margin-top: 25px;
          font-size: 14px;
          font-weight: 500;
          .answer {
            color: #1dc11d;
            display: inline-block;
            border-bottom: 1px solid #1dc11d;
            margin-right: 20px;
          }
        }
        .topic_option {
          margin-top: 15px;
          .select_option {
            display: flex;
            margin-top: 5px;
            span {
              &:first-of-type {
                margin-right: 5px;
              }
            }
          }
          .select_right {
            color: #1dc11d;
          }
          .select_error {
            color: #ff0000;
          }
        }
      }
      .knowledge {
        border: 1px solid #dddddd;
        height: 38px;
        display: flex;
        justify-content: space-between;
        align-items: center;
        margin: 0px 12px 16px 12px;
        padding: 0px 12px;
        .knowledge_content {
          font-size: 12px;
          color: #666666;
          line-height: 18px;
        }
        .intelligent_tutoring {
          font-size: 14px;
          line-height: 22px;
          width: 80px;
          cursor: pointer;
          i {
          }
        }
      }
      .next {
        position: absolute;
        bottom: 0;
        display: flex;
        flex-direction: row;
        justify-content: flex-end;
        background-color: #eeeeee;
        height: 56px;
        width: 100%;
        .next_btn {
          cursor: pointer;
          padding: 0 15px;
          font-size: 14px;
          line-height: 28px;
          margin-right: 48px;
          margin: 12px 48px 12px 0;
          height: 28px;
          background-color: #0079fe;
          color: #fff;
          border-radius: 4px;
        }
        .isdisabled {
          opacity: 0.5;
          cursor: not-allowed;
        }
      }
    }
    .timer2 {
      position: fixed;
      margin-left: 672px;
    }
    /*.timer {*/
    /*  margin-left: 48px;*/
    /*}*/
    .timer,
    .timer2 {
      background-color: #333333;
      border-radius: 4px;
      width: 192px;
      /*max-height: 610px;*/
      .time_number {
        height: 160px;
        color: #fff;
        /*background: url("../assets/images/back-time.png") no-repeat;*/
        background-size: 288px 160px;

        .timing {
          padding: 39px 0;
          display: flex;
          flex-direction: column;
          justify-content: center;
          .title {
            font-size: 16px;
            line-height: 22px;
            text-align: center;
          }
          .number {
            font-size: 40px;
            line-height: 56px;
            text-align: center;
          }
        }
      }
      .errdata_record {
        color: #ffffff;
        .record_part1 {
          display: flex;
          flex-direction: column;
          align-items: center;
          .title {
            font-size: 16px;
            line-height: 22px;
            margin-top: 26px;
          }
          .total_num {
            font-size: 40px;
            line-height: 56px;
          }
          .wancheng_num {
            font-size: 14px;
            line-height: 22px;
          }
        }
        .record_part2 {
          display: flex;
          justify-content: space-around;
          .nav1,
          .nav2 {
            display: flex;
            flex-direction: column;
            text-align: center;
            .isright {
              margin: 12px 0;
              font-size: 14px;
              line-height: 22px;
            }
            .num {
              font-size: 32px;
              line-height: 36px;
            }
          }
        }
        .record_part3 {
          display: flex;
          flex-direction: column;
          align-items: center;
          .btn {
			background-color: #333333;
			border-radius: 40px;
			border: 1px solid #fff;
            /*background-color: #0079fe;*/
            width: 88px;
            height: 32px;
            cursor: pointer;
            color: #ffffff;
            text-align: center;
            font-size: 14px;
            /*border-radius: 4px;*/
            line-height: 32px;
            margin-top: 60px;
          }
          .tips {
            margin-top: 16px;
            font-size: 12px;
            color: #999999;
          }
        }
        .record_part3_step2 {
          display: flex;
          flex-direction: row;
          justify-content: center;
          .btn {
            background-color: #0079fe;
            width: 88px;
            height: 32px;
            cursor: pointer;
            color: #ffffff;
            text-align: center;
            font-size: 14px;
            border-radius: 4px;
            line-height: 32px;
            margin-top: 60px;
            &:first-of-type {
              margin-right: 24px;
            }
          }
        }
      }
    }
  }
  .video_div {
    border: 1px solid #eeeeee;
    .no_videoUrl {
      width: 536px;
      height: 288px;
      display: flex;
      flex-direction: column;
      justify-content: center;
      text-align: center;
    }
  }
}
</style>
